import { MetodoPagoEnum } from "src/app/cotizacion/enum/metodoPago";
import { CotizacionZurich } from "./casa-habitacion-zurich.model";
import { ConfigPaq, GenericOptions } from "./configPaq.model";

export class CasaHabitacion {
    public casaHabitacionCotizacion: CasaHabitacionCotizacion = new CasaHabitacionCotizacion();
    public ubicacionRiesgo: UbicacionRiesgo = new UbicacionRiesgo();
    public contratante: Contratante = new Contratante();
    public producto: Producto = new Producto();
    public paquetes: Array<Paquete> = new Array<Paquete>();
    public formasPago: Array<FormaPago> = new Array<FormaPago>();
    public codigoPostalCasaHabitacion: CodigoPostalCasaHabitacion = new CodigoPostalCasaHabitacion();
    public paqueteSeleccionado: number = 0;
    public formaPagoSeleccionado: number = 0;
    public ciaID: number = 0;
    public grupoEstructuraID: number = 0;
    public cotizacionID: number = 0;
    public primas: Primas = new Primas();
    public coberturas: Array<Cobertura> = new Array<Cobertura>();
    public solicitud: string = "";
    public rfc: string = "";
    public vigInicial: string = "";
    public vigFinal: string = "";
    public coberturasNegocio: Array<Cobertura> = new Array<Cobertura>();
    public nombrePaqueteInvidual: string = "";
    public nomina: string = "";
    public configPaq: ConfigPaq = new ConfigPaq();
    public paquetesZurich: Array<GenericOptions> = new Array<GenericOptions>();
    public jsonCotizacion: CotizacionZurich = new CotizacionZurich();
    public formasCobro?: Array<FormasCobroHogar> = [];
    public esPyme: boolean = false;
}
export class Contratante {
    public nombre: string = "";
    public apPat: string = "";
    public apMat: string = "";
    public fechaNacimiento: string = "";
    public correo: string = "";
}
export class Producto {
    public titulo: string = "";
    public subTitulo: string = "";
    public logoAseguradora: string = "";
}
export class CasaHabitacionCotizacion {
    public negocioID: number = 0;
    public valorInmueble: number = 0;
    public cp: string = "";
}
export class UbicacionRiesgo {
    public calle: string = "";
    public colonia: string = "";
    public noInterior: string = "";
    public noExterior: string = "";
    public cp: string = "";
    public municipio: string = "";
    public estado: string = "";
    public zonaTev: string = "";
    public zonaFhim: string = "";
    public giro: string = "";
    public equipoSeguridad: string = "";
    public entrePisos: string = "";
    public techos: string = "";
    public muros: string = "";
    public estructura: string = "";
    public numeroPisos: number = 0;
    public isDueño: boolean = false;
    public mismaDireccionContratante: boolean = false;
    public incluirFenomenos: boolean = false;
    
    public edad: number = 0;
    public material: number = 0;
    public cuerpoAgua: number = 0;
    public proteccion: boolean = false;
    public alarmaLocal: boolean = false;
    public alarmaCentral: boolean = false;
    public vigilancia: boolean = false;

}
export class Paquete {
    public paqueteID: number = 0;
    public nombre: string = "";
    public primas: Primas = new Primas();
    public coberturas: Array<Cobertura> = new Array<Cobertura>();
}
export class Cobertura {
    public coberturaID: number = 0;
    public nombre: string = "";
    public sumaAsegurada: any = 0;
    public prima: number = 0;
    public orden: number = 0;
    public incluido: boolean = false;
    public imagen: string = "";
    public descripcion: string = "";
    public descripcion1: string = "";
    public descripcion2: string = "";
}
export class Primas {
    public primaNeta: number = 0;
    public subTotal: number = 0;
    public derecho: number = 0;
    public iva: number = 0;
    public total: number = 0;
}
export class CodigoPostalCasaHabitacion {
    public colonias: Array<ColoniaCasaHabitacion> = new Array<ColoniaCasaHabitacion>();
    public municipio: MunicipioCasaHabitacion = new MunicipioCasaHabitacion();
    public estado: EstadoCasaHabitacion = new EstadoCasaHabitacion();
    public ciudad: CiudadCasaHabitacion = new CiudadCasaHabitacion();
    public zonaHidro: string = "";
    public zonaTerremoto: string = "";
}
export class ColoniaCasaHabitacion {
    public colonia: string = "";
    public tipoAsentamiento?: string = "";
    public zona?: string = "";
    public id: number = 0;
}
export class MunicipioCasaHabitacion {
    public municipio: string = "";
}
export class EstadoCasaHabitacion {
    public estado: string = "";
}
export class CiudadCasaHabitacion {
    public ciudad: string = "";
}
export class FormaPago {
    public primaNeta: number = 0;
    public derecho: number = 0;
    public subTotal: number = 0;
    public iva: number = 0;
    public primaTotal: number = 0;

    public formaPagoID: number = 0;
    public nombre: string = "";
    public inicial: any = 0;
    public subsecuente: any = 0;
    public clave: string = "";
    public numSubs: number = 0;
}
export class FormasCobroHogar {
    id: number = 0;
    nombre: string = "";
    cveCia: string = "";
    metodo: MetodoPagoEnum = MetodoPagoEnum.EMITE;
    cuenta?: number;
    negocioID?: number;
    hidden?: boolean;
}